import { render } from "./AppCompass.vue?vue&type=template&id=18a8bb0a&scoped=true"
import script from "./AppCompass.vue?vue&type=script&lang=js"
export * from "./AppCompass.vue?vue&type=script&lang=js"

import "./AppCompass.vue?vue&type=style&index=0&id=18a8bb0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a8bb0a"]])

export default __exports__